module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Agregadores\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "header-action"
  }, [_c('div', {
    staticClass: "form-group search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.plate),
      expression: "plate",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-plate",
      rawName: "v-mask-plate"
    }],
    staticClass: "form-control upper",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "data-vv-validate-on": "blur",
      "autofocus": "autofocus",
      "placeholder": "Buscar por placa"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      },
      "change": function($event) {
        _vm.plate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-search-input",
    on: {
      "click": _vm.search
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-square",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modalAggregate()
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n        Cadastrar Agregador\n      ")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-warning margin-t20"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.length > 0) ? _c('div', {}, [_c('table', {
    staticClass: "table table-flat"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(vehicle, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center bold"
    }, [_vm._v(_vm._s(vehicle.plate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(vehicle.tagSerialNumber == 0 ? '' : vehicle.tagSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.modelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.categoryAxesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.brandName))]), _vm._v(" "), _c('td', {
      staticClass: "ico-info text-center"
    }, [(vehicle.reason == 'Desbloqueado') ? _c('i', {
      staticClass: "icomoon-truck-ok text-center"
    }) : (vehicle.reason == 'Temporariamente') ? _c('i', {
      staticClass: "icomoon-truck-block text-center"
    }) : [_vm._v(_vm._s(vehicle.reason))]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "dropdown drop-actions"
    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "aria-labelledby": ""
      }
    }, [(vehicle.tagSerialNumber) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.typeAggregate = 'replace';
          _vm.showBlockModal(vehicle)
        }
      }
    }, [_c('i', {
      staticClass: "icon-sync"
    }), _vm._v("\n                    Substituir TAG\n                  ")])]) : _vm._e(), _vm._v(" "), _c('li', [(!_vm.showUnblock(vehicle)) ? _c('a', {
      attrs: {
        "data-toggle": "tooltip",
        "title": "Bloquear veículo temporariamente"
      },
      on: {
        "click": function($event) {
          _vm.typeAggregate = 'block';
          _vm.showBlockModal(vehicle)
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-blocked"
    }), _vm._v("\n                    Bloquear veículo\n                  ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.showUnblock(vehicle)) ? _c('a', {
      attrs: {
        "data-toggle": "tooltip",
        "title": "Bloquear veículo temporariamente"
      },
      on: {
        "click": function($event) {
          _vm.typeAggregate = 'unblock';
          _vm.showBlockModal(vehicle)
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-blocked"
    }), _vm._v("\n                    Desbloquear veículo\n                  ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "data-toggle": "tooltip",
        "title": "Excluir veículo"
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteModal(vehicle)
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-delete"
    }), _vm._v("\n                    Excluir veículo\n                  ")])])])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.length > 0) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "result-table-count"
  }, [_vm._v("\n        Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n        encontrados.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row results"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "btn no-btn btn-square margin-10",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('pagination', {
    attrs: {
      "model": _vm.page
    },
    on: {
      "page-change": _vm.setCurrentPage
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn no-btn btn-square margin-10",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_vm._v("\n          Voltar\n        ")])], 1)])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "btn no-btn btn-square margin-10",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_vm._v("\n        Voltar\n      ")])], 1)]), _vm._v(" "), (_vm.showModalAggregate) ? _c('modal-aggregate', {
    attrs: {
      "contractAggregate": _vm.contractAggregate
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicleToBlock) ? _c('modal-block-vehicle', {
    attrs: {
      "vpSelected": _vm.vpSelected,
      "type": _vm.typeAggregate
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("TAG N°")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Eixos")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("Marca")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "no-btn",
    attrs: {
      "id": "",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icon-actions.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-04eaec87!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/aggregate-list.vue
// module id = 2039
// module chunks = 1